var scope_0 = require('/codebuild/output/src2646419050/src/redacted-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/be41c240a919957fb8ce997fa8b7957f.js').default;
var scope_1 = require('/codebuild/output/src2646419050/src/redacted-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    